module.exports = {
    'gifting.store': 'customers/gifts',
    'gifting.prices.index': 'gifts/prices',
    'gifting.delivery-days.index': 'zones/deliverable-days',
    'gifting.incomplete.create': 'user/$1/incomplete-giftings',
    'gifting.incomplete.update': 'user/$1/incomplete-giftings/$2',
};
